import classnames from 'classnames';
import React, { FC } from 'react';
import { GenericLayout } from '../Generic';
import { ISmartGridLayout } from '../types';
import { SmartGridItem } from './SmartGridItem';
import styles from './SmartGridLayout.scss';
import { SmartGridLoadingIndicator } from './SmartGridLoadingIndicator';

export const SmartGridLayout: FC<ISmartGridLayout> = ({
  className,
  isLoading,
  hasMoreItems,
  dataHook = 'smart-grid-layout',
  children,
  onClick,
  onContextMenu,
  loadMoreItems,
  resetFilesStream,
  itemsCount,
  extendedFiltersElement,
  itemsClassName,
  selectItem,
  saveRef,
  isSquare,
  searchQuery,
  otherCategoriesWithResults,
  handleCategoryTagClick,
}) => (
  <GenericLayout
    className={classnames(styles.smartGridLayout, className)}
    itemsClassName={classnames(styles.items, itemsClassName)}
    isLoading={isLoading}
    hasMoreItems={hasMoreItems}
    onClick={onClick}
    onContextMenu={onContextMenu}
    loadMoreItems={loadMoreItems}
    dataHook={dataHook}
    resetFilesStream={resetFilesStream}
    itemsCount={itemsCount}
    extendedFiltersElement={extendedFiltersElement}
    selectItem={selectItem}
    saveRef={saveRef}
    stickyThreshold={58}
    searchQuery={searchQuery}
    otherCategoriesWithResults={otherCategoriesWithResults}
    handleCategoryTagClick={handleCategoryTagClick}
  >
    {children({
      File: SmartGridItem,
      LoadingIndicator: SmartGridLoadingIndicator,
      itemClassName: classnames(styles.item, { [styles.smallerItem]: isSquare }),
    })}
  </GenericLayout>
);
